import { ChevronDown, ChevronUp } from 'baseui/icon'

// eslint-disable-next-line react/prop-types
const CustomToggleIcon = ({ $expanded, $style, ...restProps }) => {
  const mergedStyle = {
    ...$style,
    width: '1.75rem',
    height: '1.75rem',
  }
  return $expanded ? (
    <ChevronUp color='#808284' {...restProps} style={mergedStyle} />
  ) : (
    <ChevronDown color='#808284' {...restProps} style={mergedStyle} />
  )
}

export default CustomToggleIcon
